module.exports = __webpack_public_path__ + "static/media/gadzety_kreatywne_01_B.865b4723.png";